import { UrlTree, DefaultUrlSerializer } from '@angular/router';

/**
 * Lowercases URL path and query parameter keys for case-insensitive routing/reads.
 * Query values and hash are preserved as-is (OAuth codes, state, GUIDs, etc.).
 */
export class LowerCaseUrlSerializer extends DefaultUrlSerializer {
  parse(url: string): UrlTree {
    const hashIdx = url.indexOf('#');
    const queryIdx = url.indexOf('?');
    let path: string;
    let query = '';
    let hash = '';
    if (queryIdx !== -1 && (hashIdx === -1 || queryIdx < hashIdx)) {
      path = url.slice(0, queryIdx);
      const rest = url.slice(queryIdx);
      const hashStart = rest.indexOf('#');
      if (hashStart !== -1) {
        query = rest.slice(0, hashStart);
        hash = rest.slice(hashStart);
      } else {
        query = rest;
      }
    } else if (hashIdx !== -1) {
      path = url.slice(0, hashIdx);
      hash = url.slice(hashIdx);
    } else {
      path = url;
    }
    return super.parse(path.toLowerCase() + normalizeQueryKeys(query) + hash);
  }
}

function normalizeQueryKeys(query: string): string {
  if (!query) {
    return query;
  }
  const hasLeadingQuestion = query.startsWith('?');
  const raw = hasLeadingQuestion ? query.slice(1) : query;
  if (!raw) {
    return query;
  }
  const normalized = raw.split('&').map(part => {
    const eq = part.indexOf('=');
    if (eq < 0) {
      return part.toLowerCase();
    }
    return part.slice(0, eq).toLowerCase() + '=' + part.slice(eq + 1);
  }).join('&');
  return (hasLeadingQuestion ? '?' : '') + normalized;
}
